// Local development against the Firebase emulators. Only `npm run dev:local`
// (and the e2e smoke test) build with VITE_USE_EMULATORS=true, via
// `.env.emulators`; Vite inlines the comparison, so in every other build this
// is the constant `false` and whatever it guards is dropped from the bundle.
export const USE_EMULATORS = import.meta.env.VITE_USE_EMULATORS === "true";

// `demo-` projects need no credentials, and the emulators refuse to talk to a
// real backend for them, so nothing here can touch production.
export const EMULATOR_PROJECT_ID = "demo-triptracker";

// 127.0.0.1 rather than localhost: the emulators only bind IPv4 in the cloud
// containers, and `localhost` can resolve to ::1 first.
export const EMULATOR_HOST = "127.0.0.1";

// Must match `emulators` in firebase.json.
export const EMULATOR_PORTS = {
  auth: 9099,
  firestore: 8080,
  database: 9000,
  functions: 5001,
  storage: 9199,
} as const;

// The account `scripts/seed-emulators.ts` creates, offered on the Login page in
// emulator builds only.
export const EMULATOR_TEST_USER = {
  email: "traveler@example.com",
  password: "triptracker",
} as const;
